//Components
import { Text, Flex } from '@/components';

//Icons
import { CheckIcon } from '@/assets/icons';

const CheckBox = ({
  color,
  name,
  active,
  action = () => {},
  w = 'fit-content'
}) => {
  return (
    <Flex
      align="center"
      justify="space-between"
      onClick={() => action()}
      w={w}
      style={{
        cursor: 'pointer'
      }}
    >
      <Text clave={name} color="#1F2937" />
      <div
        style={{
          height: 13,
          width: 13,
          border: `1px solid ${color}`,
          marginLeft: 10,
          borderRadius: 2,
          color: 'white',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: active && color
        }}
      >
        {active && <CheckIcon size="13px" />}
      </div>
    </Flex>
  );
};
export default CheckBox;
